import { mapGetters } from 'vuex';
import Cookies from 'js-cookie';

const TokenKey = 'is_logged';

export const AuthMixin = {
  computed: {
    ...mapGetters('app', ['appConfig']),
  },
  methods: {
    isLogged() {
      return Cookies.get(`${TokenKey}_${this.appConfig.cookieSurffix}`) === '1';
    },
    setLogged() {
      // TODO: set for multi domain
      Cookies.set(`${TokenKey}_${this.appConfig.cookieSurffix}`, '1');
    },
    removeLogged() {
      Cookies.remove(`${TokenKey}_${this.appConfig.cookieSurffix}`);
    },
  },
};
